import { PrimeReactModal } from "@finanedi.es/storybook"
import { InputText } from "primereact/inputtext"
import { ModalFooter } from "./ModalFooter"
import { ModalLogo } from "./ModalLogo"
import { PRIME_REACT_MODAL_DEFAULT_PROPS, STATE } from "./_constants"
import { StepOneModalProps } from "./_interfaces"

export function StepOneOtpModal({
  firstConfirm,
  bankSelected,
  connectingData,
  setConnectingData,
  form,
  onStepOneConfirm,
  setSelectedDocumentType,
  stepOneModalState,
}: StepOneModalProps) {
  const verificationCode = firstConfirm[STATE.GET]?.additionalInfo?.otp
  const errorCodes = [1000, 2000, 3000, 3001, 50000, 6001]
  const inputOtpCodes = [50002, 50009]
  const infoOtpCodes = [1000, 2000, 3000, 50000, 50003, 6000]
  const hasError = errorCodes.some(
    (code) => code === firstConfirm[STATE.GET]?.longCode
  )
  const isAnInformativeCode = infoOtpCodes.some(
    (code) => code === firstConfirm[STATE.GET]?.longCode
  )
  const needsOtp = inputOtpCodes.some(
    (code) => code === firstConfirm[STATE.GET]?.longCode
  )

  const handleClose = (): void => {
    stepOneModalState[STATE.SET](false)
    firstConfirm[STATE.SET](undefined)
    form[STATE.SET]({})
    setSelectedDocumentType(null)
  }

  return (
    <PrimeReactModal
      ptContext={{
        dialog: PRIME_REACT_MODAL_DEFAULT_PROPS.dialog,
        calendar: PRIME_REACT_MODAL_DEFAULT_PROPS.calendar,
        dropdown: PRIME_REACT_MODAL_DEFAULT_PROPS.dropdown,
        inputtext: PRIME_REACT_MODAL_DEFAULT_PROPS.inputtext,
      }}
      className='tw-w-128 tw-max-w-full tw-h-fit tw-max-h-full tw-flex tw-flex-col tw-gap-2'
      onHide={handleClose}
      closeOnEscape
      visible={Boolean(firstConfirm[STATE.GET]?.additionalInfo?.otp)}
      focusOnShow={false}
      header='Vincular tarjeta'
      footer={
        <ModalFooter
          onCancel={handleClose}
          onConfirm={async () => {
            try {
              setConnectingData(true)
              await onStepOneConfirm?.({
                bankSelected,
                formData: {
                  ...form[STATE.GET],
                  service: bankSelected?.service ?? "",
                  ...(verificationCode
                    ? {
                        counterId: verificationCode?.counterId ?? "",
                        sessionId: verificationCode?.sessionId ?? "",
                      }
                    : {}),
                },
              })
              form[STATE.SET]((prevData) => ({
                ...prevData,
                ...(verificationCode
                  ? {
                      counterId: verificationCode?.counterId ?? "",
                      sessionId: verificationCode?.sessionId ?? "",
                    }
                  : {}),
              }))
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error("Error connecting bank", error)
            } finally {
              setConnectingData(false)
            }
          }}
          isButtonLoading={connectingData}
          confirmButtonProps={{
            disabled: Boolean(
              form[STATE.GET]?.user &&
                form[STATE.GET]?.pass &&
                verificationCode &&
                Boolean(!form[STATE.GET]?.otp && !isAnInformativeCode)
            ),
          }}
        />
      }
    >
      <ModalLogo bankSelected={bankSelected} />
      {firstConfirm[STATE.GET]?.message}
      {!isAnInformativeCode && !hasError && needsOtp && (
        <InputText
          id='bankSelectedDataOtp'
          placeholder='2FA'
          autoComplete='new-password'
          value={form[STATE.GET]?.otp?.toString() ?? ""}
          onChange={(e) =>
            form[STATE.SET]((prevData) => ({
              ...prevData,
              otp: e.target.value,
            }))
          }
        />
      )}
    </PrimeReactModal>
  )
}
